import {
	 IDictionary,
	 OneOrMany 
} from 'util/domain';
import { ContextMenuService } from 'sharebase/services/contextMenuService';
import {
	Menu,
	IMenuItem,
	MenuItemContext
} from 'sharebase/domain';
import { MenuFactory } from 'sharebase/factories/menuFactory';
import {
	pxItemTypeGuards,
	PermissionType,
	ShareBaseItem
} from 'phoenix/domain';
import { AppAction } from '../components/_app/app.actions';
import { DocumentAction } from '../components/documentView/documentView.actions';
import { FolderAction } from '../components/folderView/folderView.actions';
import { AclDatastore } from 'sharebase/dataStores/aclDatastore';
import { ActionService } from 'phoenix/services/actionService';
import { ActionRepository } from 'sharebase/services/actionRepository';
export interface SelectionDataStore {
	readonly selectedItems:any[];
	readonly selectionActions:IMenuItem[];
	readonly isInSelectionMode:boolean;
	readonly toolbar:Menu;
	clearSelection():void;
	setItemSelect(item:any):void;
	selectItems(items:any[]):void;
	renameItem(item:any, newName:string):void;
}

/**
* @ngdoc service
* @name  sharebase-app.sbaSelectionDataStore
* 
* @description 
* A datastore used to interact with list selections
* 
**/
export function SelectionDataStoreFactory(
	$q: ng.IQService,
	pxActionService:ActionService,
	sbMenuFactory:MenuFactory,
	sbActionRepository:ActionRepository
) {			
	let selected = [];
	let activeMenuItems:IMenuItem[] = [];
	let toolbar = sbMenuFactory.create();
	toolbar.addItem = (original => {
		return (i:IMenuItem) => {
			let action = sbActionRepository.getAction(i.action);
			i.context = MenuItemContext.SelectionBar;
			if(action && !action.multiItem){
				i.addMiddleware((target:OneOrMany<ShareBaseItem>) => {
					if(Array.isArray(target)){
						return target.length === 1 ? target[0] : null;
					}
					else {
						return target;
					}
				});
			}				

			return original.call(toolbar, i);
		};
	})(toolbar.addItem);

	const store:SelectionDataStore = {
		toolbar,
		/**
		* @ngdoc method
		* @name sbaSelectionDataStore#clearSelection
		* @propertyOf sharebase-app.sbaSelectionDataStore
		* @kind function
		*
		* @description
		* Clears all selected items
		*
		*/
		clearSelection,

		/**
		* @ngdoc method
		* @name sbaSelectionDataStore#setItemSelection
		* @propertyOf sharebase-app.sbaSelectionDataStore
		* @kind function
		*
		* @description
		* Toggles selection of item
		*
		*/
		setItemSelect,
		/**
		* @ngdoc method
		* @name sbaSelectionDataStore#selectItems
		* @propertyOf sharebase-app.sbaSelectionDataStore
		* @kind function
		*
		* @description
		* Sets all items passed in as selected
		*
		* @param {array} items An array of folder/document resource objects
		*/
		selectItems,
		/**
		* @ngdoc method
		* @name sbaSelectionDataStore#renameItem
		* @propertyOf sharebase-app.sbaSelectionDataStore
		* @kind function
		*
		* @description
		* Renames an item renamed through selection
		*
		* @param {object} item A ShareBaseItem being renamed

		*/
		renameItem,			

		/**
		* @ngdoc property
		* @name sbaSelectionDataStore#selectedItems
		* @propertyOf sharebase-app.sbaSelectionDataStore
		* @kind property
		*
		* @description
		* Selected items 
		*
		* @returns {array} An array of a selected items
		*/
		get selectedItems() { return selected; },
		/**
		* @ngdoc property
		* @name sbaSelectionDataStore#selectionActions
		* @propertyOf sharebase-app.sbaSelectionDataStore
		* @kind property
		*
		* @description
		* Gets actions for the selected items 
		*
		* @returns {array} An array of a actions
		*/
		get selectionActions() { return activeMenuItems; },
		/**
		* @ngdoc property
		* @name sbaSelectionDataStore#selectionActions
		* @propertyOf sharebase-app.sbaSelectionDataStore
		* @kind property
		*
		* @description
		* Gets actions for the selected items 
		*
		* @returns {array} An array of a actions
		*/
		get isInSelectionMode() { return selected.length > 0; },
	};
	
	pxActionService.subscribe(AppAction.RefreshSelectionBar, setActions);

	return store;

	function clearSelection(){
		selected.forEach(function(item){
			item.selected = false;
		});
		
		selected = [];
		activeMenuItems = [];
	}

	function setItemSelect(item){				
		var idProp = '';
		if(item.FolderId){
			idProp = 'FolderId';
		}
		else if(item.DocumentId){
			idProp = 'DocumentId';
		}
		else{
			idProp = 'LibraryId';
		}

		// remove from selection first to ensure no duplicates	
		selected = selected.filter(function(selectedItem) { 
			return idProp in selectedItem ? selectedItem[idProp] !== item[idProp] : true; 
		});

		if(item.selected){		
			selected.push(item);
		}

		setActions();
		
	}

	function setActions(){
		activeMenuItems = [];
		
		if(selected.length > 0) {
			store.toolbar
				.getActiveItems(selected)
				.then(items => activeMenuItems = items);
		}
	}

	function selectItems(items:any[]){
		selected = items.map(function(item){ 
			item.selected = true;
			return item;
		});

		setActions();
	}



	function renameItem(item, newName) {
		if (item.DocumentId) {
			selected = selected.map(document => {
				if (document.DocumentId === item.DocumentId) {
					document.DocumentName = newName;
				}
				return document;
			});
		}
		else if (item.FolderId) {
			selected = selected.map(folder => {
				if (folder.FolderId === item.FolderId) {
					folder.FolderName = newName;
				}
				return folder;
			});
		}
	}
}

SelectionDataStoreFactory.$inject = [
	'$q',
	'pxActionService',
	'sbMenuFactory',
	'sbActionRepository'
];


// WEBPACK FOOTER //
// ./src/sharebase-app/dataStores/selectionDataStore.ts